import { render, staticRenderFns } from "./PhoneBind.vue?vue&type=template&id=3a478f3e&scoped=true&"
import script from "./PhoneBind.vue?vue&type=script&lang=js&"
export * from "./PhoneBind.vue?vue&type=script&lang=js&"
import style0 from "@/common/styles/mixin/account-bind.scoped.styl?vue&type=style&index=0&id=3a478f3e&lang=stylus&scoped=true&"
import style1 from "./PhoneBind.vue?vue&type=style&index=1&id=3a478f3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a478f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
